import React from 'react';
import _ from 'root/libs/exaforte/react/lodash';
import {ThemeProvider as MuiThemeProvider} from '@material-ui/core/styles';
import { KeyboardDatePicker, DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import CustomDate from 'root/libs/exaforte/react/CustomDate';
import CustomFormInput from './CustomFormInput';
import moment from 'moment';

moment.locale('nl');

export default class CustomDatePicker extends CustomFormInput {
    _onChange(value) {
        if(value)
            this.props.onChangeText(value.format('YYYY-MM-DD'));
        else
            this.props.onChangeText(null);
    }
    
    getSupportedProps() {
        return {...super.getSupportedProps(), ..._.filterSupportedProps(this.props, {variant: true, format: true, cancelLabel: true, minDate: true, maxDate: true, minDateMessage: true, maxDateMessage: true, invalidDateMessage: true})};
    }
    
    getElement() {
        let props                   = this.getSupportedProps();
        let Picker                  = (typeof this.props.allowKeyboard == 'undefined' || this.props.allowKeyboard ? KeyboardDatePicker : DatePicker);
        props.variant               = props.variant || 'inline';
        props.invalidDateMessage    = props.invalidDateMessage || '';
        
        if(props.variant != 'inline')
            props.cancelLabel = props.cancelLabel || 'Annuleren';
        
        if(!props.format)
            props.format = 'DD-MM-YYYY';
            
        if(typeof props.value == 'string')
            props.value = new CustomDate(props.value);

        return <Picker onChange={this._onChange} InputProps={{ disableUnderline: true }} {...props} />;
    }
    
    render() {
        let datepicker = (<MuiPickersUtilsProvider utils={MomentUtils} locale={'nl'}>{super.render()}</MuiPickersUtilsProvider>);
            
        if(!this.props.theme)
            return datepicker;

        return (<MuiThemeProvider theme={this.props.theme}>
            {datepicker}
        </MuiThemeProvider>);
    }
}